import styled from "styled-components";
import { LabelText, SectionTitle, ValueText } from "./styles";

const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 8px;
  margin-top: 16px;
  flex-wrap: wrap;
  background-color: #ececec;
  padding: 8px 16px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const CategoryIcon = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 8px;
`;

const StyledCard = styled.div`
  margin: 0;
  padding: 16px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const UtilityProviderCard = ({
  utilityProviders,
}: {
  utilityProviders: {
    _id: string;
    category: {
      category: string;
      title: string[];
      icon: string;
    };
    title: string;
    gprn?: string;
    mprn?: string;
  }[];
}) => {
  return (
    <StyledCard style={{ margin: 0 }}>
      <SectionTitle>Utility Providers</SectionTitle>
      {utilityProviders.map((provider) => (
        <InfoRow key={provider._id}>
          <div style={{ width: "200px" }}>
            <LabelText>Provider Name:</LabelText>
            <ValueText>{provider.title}</ValueText>
          </div>
          <div style={{ flex: 1 }}>
            <LabelText>GPRN:</LabelText>
            {provider.gprn && <ValueText>{provider.gprn}</ValueText>}
          </div>
          <div style={{ flex: 1 }}>
            <LabelText>MPRN:</LabelText>
            {provider.mprn && <ValueText>{provider.mprn}</ValueText>}
          </div>
          <div style={{ width: "210px" }}>
            <LabelText style={{ textAlign: "right" }}>Category:</LabelText>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <CategoryIcon src={provider.category.icon} alt="Category icon" />
              <ValueText>{provider.category.category}</ValueText>
            </div>
          </div>
        </InfoRow>
      ))}
    </StyledCard>
  );
};

export default UtilityProviderCard;
